class AnchorNav extends window.BAO.CustomElement() {
  static get requiredExternalEls () {
    return ['anchor']
  }

  static get requiredEls () {
    return ['list']
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.renderNav()
  }

  renderNav () {
    this.els.list.innerHTML = ''

    for (const anchor of this.externalEls.anchor.elements) {
      const listItem = document.createElement('li')

      listItem.classList.add('anc-Nav_Item')
      listItem.innerHTML = `<a class="anc-Nav_Link" href="#${anchor.id}">${anchor.dataset.navLabel}</a>`

      const link = listItem.querySelector('.anc-Nav_Link')

      link.addEventListener('click', this.handleClick)

      this.els.list.element.appendChild(listItem)
    }
  }

  handleClick (e) {
    e.preventDefault()

    const href = e.target.getAttribute('href')
    if (!href) return

    const targetElement = document.querySelector(href)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

window.customElements.define('anchor-nav', AnchorNav)
